import { render } from "./BatchPage.vue?vue&type=template&id=2cf41385&scoped=true"
import script from "./BatchPage.vue?vue&type=script&lang=js"
export * from "./BatchPage.vue?vue&type=script&lang=js"

import "./BatchPage.css?vue&type=style&index=0&id=2cf41385&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf41385"]])

export default __exports__